import { createAction } from 'redux-act'
import { push } from 'react-router-redux'
import API from 'api'

export const read = createAction('giftCard/read')
export const update = createAction('giftCard/update')
export const clear = createAction('giftCard/clear')

export const request = createAction('giftCard/request')
export const receive = createAction('giftCard/receive')

export const updateGiftCardData = (data) => (dispatch) => {
  dispatch(update(data))
}

export const clearGiftCard = () => (dispatch) => {
  dispatch(clear())
}

export const fetch = (id, giftCardId, lang) => (dispatch) => {
  dispatch(request({ id }))

  return API.getGiftCard(id, giftCardId, lang)
    .then(response => {
      dispatch(read(response))
    })
}

export const create = (id, giftCardId, data) => (dispatch) => {
  dispatch(request({ id, data }))

  return API.buyGiftCard(id, giftCardId, data)
    .then(response => {
      dispatch(receive({ id, response }))
      let url = window.location.pathname
      if (!/gift-card/.test(url)) {
        url = `${window.location.pathname}/gift-card`
      }
      dispatch(push(`${url}${window.location.search}`))
      return Promise.resolve(response)
    })
}
